import { makeSelectIsRoleTenantAdmin } from 'containers/App/selectors';
import usePermissions from 'containers/Permissions/usePermissions';
import { useTypedSelector } from 'hooks';

/** Gate for the starters that queue a report. Suppressed while permissions are still loading. */
export const useReportsGrant = (): boolean => {
  const { loading, actions } = usePermissions('reports');
  const isRoleTenantAdmin = useTypedSelector(makeSelectIsRoleTenantAdmin());

  return (
    !loading && (isRoleTenantAdmin === true || actions.includes('view') || actions.includes('edit'))
  );
};

export default useReportsGrant;
